module.exports = __webpack_public_path__ + "media/dashboard/assets/images/conver_tables-28114f69916f998f23959fe585bfab92.png";